module.exports={close:"Schließen",error:"Fehler",info:"Informationen",success:"Erfolg",warning:"Warnung"};